import { Controller } from "stimulus"

export default class extends Controller {

  update(event) {
    $('#referral-code-submit-btn').trigger('click');
  }
}
